import React from 'react';
import styled from 'styled-components';
import PageTransition from 'gatsby-v2-plugin-page-transitions';

import Page from '../components/global/page';
import EventsTemplate from '../templates/events-template';
import { graphql } from 'gatsby';

const StyledPage = styled.div`
	.inner nav.pages ul li:not(.button-link) a {
		&.events {
			font-weight: 700;
		}
	}
`;

export const query = graphql`
	{
		events: allEventsJson(
			filter: { is_published: { eq: true } }
			sort: { fields: date, order: ASC }
		) {
			nodes {
				title
				poster
				location
				date
				excerpt
				fields {
					slug
				}
			}
		}
		featured: allSettingsJson {
			nodes {
				featuredEvent
			}
		}
	}
`;

const EventsPage = ({ data }) => (
	<PageTransition>
		<StyledPage>
			<Page
				title="Events"
				desc="Learn more about our community-based events that help raise funds and awareness for mental health."
			>
				<EventsTemplate
					featured={data.featured.nodes[0].featuredEvent}
					events={data.events.nodes}
				/>
			</Page>
		</StyledPage>
	</PageTransition>
);

export default EventsPage;
